import { render, staticRenderFns } from "./DeviceElectrical.vue?vue&type=template&id=79b2235d&scoped=true&"
import script from "./DeviceElectrical.vue?vue&type=script&lang=js&"
export * from "./DeviceElectrical.vue?vue&type=script&lang=js&"
import style0 from "./DeviceElectrical.vue?vue&type=style&index=0&id=79b2235d&lang=scss&scoped=true&"
import style1 from "./DeviceElectrical.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b2235d",
  null
  
)

export default component.exports